import { RootTitle } from './root-title.component';
import { jsx as _jsx } from "react/jsx-runtime";
export var Heading3 = function Heading3(props) {
  var children = props.children;
  return /*#__PURE__*/_jsx(RootTitle, {
    level: 3,
    children: children
  });
};